(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PremDiscGroupDialogController', PremDiscGroupDialogController);

    PremDiscGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PremDiscGroup', 'PremDisc'];

    function PremDiscGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PremDiscGroup, PremDisc) {
        var vm = this;

        vm.premDiscGroup = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.premdiscs = PremDisc.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.premDiscGroup.id !== null) {
                PremDiscGroup.update(vm.premDiscGroup, onSaveSuccess, onSaveError);
            } else {
                PremDiscGroup.save(vm.premDiscGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:premDiscGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
